module.exports = __webpack_public_path__ + "img/9.c88f75ee.png";